import React, { Component } from 'react'; //different
//import Paoyingchub from './game/paoyingchub';
import jwt_decode from "jwt-decode";
import instance from "./axios-instance";
//import './build/web/igame-index-lobby-wm/style.a57427aa.css';
import Swal from 'sweetalert2'
import Systems from "./SystemFunction";
import md5 from 'md5';
class App extends Component {

    constructor(props) {
        super(props)
        this.state = {
            mainsetting: [],
            rewardlist: [],
            activePage: 1,
            checkboxcookie: false,
            isActive: false,
            formData: {}, // Contains login form data
            errors: {}, // Contains login field errors
            formSubmitted: false, // Indicates submit status of login form
            loading: true, // Indicates in progress state of login form
            pagecount: 1,
            username: null,
            settingwheel: "",
            settingcheckin: "",
            userid: null,
            phoneNumber: "",
            balance: 0,
            turnover: 0,
            turnoverdone: 0,
            totaldeposit: 0,
            totalwithdraw: 0,
            password: "",
            passwordcf: "",
            promotionredeem: null,
            mainacc: null,
            tabselect: 1,
            tabselectsec: 0,
            qrcode: null,
            stateregis: 1,
            checkboxacc: 0,
            products_page_count: 1,
            loginstate: false,
            fullname: null,
            lname: null,
            link: "",
            alert: null,
            depositstate: 0,
            stateforget: 1,
            depositamount: 0,
            stateopterror: "",
            btnisActive: true,
            otpphone: "",
            token: window.localStorage.getItem("token"),
            accnumber: null,
            accnumbertxt: null,
            withdrawamount: 0,
            rankpoint: 0,
            changepassword: false,
            linelink: "",
            errortext: "",
            trueaccount: null,
            datas: null,
            otpphoneforget: "",
            affpercent: 0,
            counter: 300,
            userrecomend: "",
            historylist: [],
            useradvice: [],
            cashoutlist: [],
            tblnextrank: [],
            tblrankall: [],
            maxwithdrawstatus: 0,
            tblprofile: [],
            prodetail: [],
            oldpassword: "",
            linkaff: "",
            webnamex: "",
            inviteSet: "",
            truegiftlink: "",
            proderedeem: [],
            qrcode: null,
            proderedeemlist: [],
            buttoncliam: false,
            limit: null,
            rankpic: "1.jpeg",
            rankname: null,
            rankob: null,
            cashoutSet: [],
            tblPopupMenu1: [],
            tblPopupMenu2: [],
            tblPopupMenu: null,
            termAndCondition: false,
            errorstatus: false,
        }
    }
    cancelredeempromotion = async (e, index) => {
        e.preventDefault();
        var token = localStorage.getItem('auth_token');
        console.log(1462222, index[0]);
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            Swal.fire({
                icon: 'warning',
                title: 'ທ່ານຕ້ອງການຍົກເລີກການໃຊ້ໂປຣ ແມ່ນ ຫຼື ບໍ່?',
                showCancelButton: true,
                confirmButtonText: 'Save',
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    await instance.post("/api/v1/usercancelpromotion", {
                        User_id: Username,
                        no: index[0].redeemno,
                        System: Systems,
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            this.confirmdeposit(null, 0);
                            Swal.fire('ດຳເນີນການຮຽບຮ້ອຍ', '', 'success')
                        }
                        else {
                            Swal.fire('ບໍ່ສາມາດດຳເນີນການໄດ້ ກະລຸນາລໍຖ້າ', '', 'error')
                        }
                    });

                }
            })
        }

    }

    redeemrank = async (e, index) => {
        e.preventDefault();
        //console.log(index);

        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            var Username = decoded.message.playerid;
            Swal.fire({
                icon: 'warning',
                title: 'ທ່ານຕ້ອງການເຄລມ Rank ຫຼື ບໍ່?',
                showCancelButton: true,
                confirmButtonText: 'Save',
            }).then(async (result) => {
                /* Read more about isConfirmed, isDenied below */
                if (result.isConfirmed) {
                    await instance.post("/api/v1/userredeemrank", {
                        User_id: Username,
                        rankno: index.no,
                        System: Systems,
                        amount: index.claimamount
                    }, {
                        headers: { Authorization: `Bearer ${token}` }
                    }).then(async (res) => {
                        if (res.data.status === 200) {
                            const datas = res.data.message;
                            this.calllisthistory(Username);
                            this.checklogin();
                            Swal.fire('ດຳເນີນການຮຽບຮ້ອຍ', '', 'success')
                        }
                        else {
                            Swal.fire('ບໍ່ສາມາດດຳເນີນການໄດ້ ກະລຸນາລໍຖ້າ', '', 'error')
                        }
                    });

                }
            })
        }

    }
    checktab(e, index) {
        //console.log(index == 2 &&  this.state.qrcode != null);
        if (index == 2 && this.state.tabselectsec == 1) {

        }
        else {
            if (index == 2 && this.state.qrcode != null) {
                this.setState({
                    tabselect: 0,
                    tabselectsec: 1,
                });
            }
            else {
                this.setState({
                    tabselect: index,
                    tabselectsec: 0,
                });
            }
        }
    }
    onChangexdep = event => {
        ////console.log(event.target.value);
        if (event.target !== undefined) {

            this.setState({ depositamount: event.target.value });
        }
    };

    handleClickdeposit = async (e, price) => {
        this.setState({
            depositamount: price

        });
    }

    confirmdeposit = async (e, num) => {
        // console.log(num)
        // e.preventDefault();
        var token = localStorage.getItem('auth_token');
        var decoded = jwt_decode(token);
        var Username = decoded.message.playerid;
        if (token != null) {
            await instance.post("/api/v1/gettrue", {
                userid: Username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                if (res.data.status === 200) {

                    this.setState({
                        trueaccount: res.data.message.tbltruewallet[0],
                    });

                }
            }).catch(async (err) => {
            });

            await instance.post("/api/v1/getredeempromotion", {
                userid: Username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                console.log(799, res);
                if (res.data.status === 200) {
                    this.setState({
                        proderedeem: res.data.message.tblpromotionredeems,
                    });

                }
                else {
                    this.setState({
                        proderedeem: null,
                    });
                }
            }).catch(async (err) => {
            });

            await instance.post("/api/v1/getqrcode", {
                username: Username,
                System: Systems,
                amount: this.state.depositamount
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //////console.log(res.data.picture)
                this.setState({
                    mainacc: res.data.mainacc,
                    qrcode: res.data.picture
                });
            });
        }
    }
    checklogin() {
        var token = localStorage.getItem('auth_token');
        if (token != null) {
            var decoded = jwt_decode(token);
            //////console.log(decoded);
            this.setState({
                userid: decoded.message.playerid,
                username: decoded.message.playerid,
                firstname: decoded.message.firstname,
                lastname: decoded.message.lastname,
                point: decoded.message.Point,
                loginstate: true,
            });
        }
        else {
            this.setState({
                loginstate: false,
            });
        }
    }
    async rechecklogin(Username, token) {

        try {
            // console.log(4);
            const search = window.location.href;
            const paramx = new URLSearchParams(search);
            // const space = search.split("/")
            const space = window.location.host
            var userhash = md5(Username);
            //  const linkaff = "https://pgline88.com/?register=" + userhash;
            const linkaff = "https://" + space + "/register?reg=" + userhash;
            instance.post("/api/v1/checkpoint", {
                userid: Username,
                System: Systems,
                Function: 'rechecklogin-navbar.js'
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                //  console.log(res.data);
                if (res.data.status === 200) {
                    localStorage.setItem('auth_token', res.data.token)
                    console.log(310, res.data.promotionredeem)
                    this.setState({
                        tblrankall: res.data.tblrankall,
                        rankpic: res.data.tblrank?.image,
                        rankname: res.data.tblrank?.name,
                        linkaff: linkaff,
                        rankob: res.data.tblrank,
                        rankpoint: res.data.rankpoint,
                        accnumber: res.data.message.accnumber,
                        userid: res.data.message.member_id,
                        tblprofile: res.data.message,
                        turnover: res.data.message.TurnOverAmount,
                        turnoverdone: (Number(res.data.message.Turnovercasino || 0) + Number(res.data.message.Turnoverslot || 0)),
                        totaldeposit: Number(res.data.rankpoint || 0),
                        totalwithdraw: Number(res.data.totalwithdraw || 0),
                        username: res.data.message.playerid,
                        fname: res.data.message.firstname,
                        point: res.data.message.Point,
                        balance: res.data.databalance,
                        promotionredeem: res.data.promotionredeem,
                        loginstate: true,
                    });
                }
                else if (res.data.status === 401) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ຂອງທ່ານໝົດອາຍຸ ກະລຸນາ login ເຂົ້າສູ່ລະບົບອີກຄັ້ງ',
                        icon: 'warning',
                        confirmButtonText: 'ຕົກລົງ'
                    })
                    window.location.href = '/';
                }

            }).catch(async (err) => {
                console.log(err)
                if (err.response.status === 401 || err.response.status === 403) {
                    localStorage.clear();
                    await Swal.fire({
                        title: 'Warning!',
                        text: 'Session ຂອງທ່ານໝົດອາຍຸ ກະລຸນາ login ເຂົ້າສູ່ລະບົບອີກຄັ້ງ',
                        icon: 'warning',
                        confirmButtonText: 'ຕົກລົງ'
                    })
                    window.location.href = '/';
                }
            });
        }
        catch (ex) {
            //////console.log(ex);
        }

    }
    async componentDidMount() {
        // this.checklogin();
        try {
            var token = localStorage.getItem('auth_token');
            //  //////console.log(token);
            if (token != null) {
                var decoded = jwt_decode(token);
                var Username = decoded.message.playerid;
                await this.rechecklogin(Username, token);
                this.setState({
                    userid: decoded.message.playerid,
                    username: decoded.message.playerid,
                    firstname: decoded.message.firstname,
                    lastname: decoded.message.lastname,
                    loginstate: true,
                });
            }
            else {
                this.setState({
                    loginstate: false,
                });
            }
            if (token != null) {
                var decoded = jwt_decode(token);
                let Username = decoded.message.playerid;
                instance.post("/api/v1/getqrcode", {
                    username: Username,
                    System: Systems,
                    amount: 50
                }, {
                    headers: { Authorization: `Bearer ${token}` }
                }).then(async (res) => {
                    //////console.log(res.data.picture)
                    this.setState({
                        mainacc: res.data.mainacc,
                    });
                });
            }
        }
        catch (error) {
            //////console.log();
        }
        try {

            await instance.post("/api/v1/mainsetting", {
                System: Systems,
            }).then((res) => {
                if (res.data.status === 200) {
                    const datas = res.data.message;
                    // console.log( datas[7].value)
                    var min = res.data.tblcatagoryx[0].limitdeposit;
                    var max = res.data.tblcatagoryx[0].maxdeposit;
                    var maxwithdrawstatus = res.data.tblcatagoryx[0].withdrawmax
                    var limit = { min, max }
                    this.setState({
                        maxwithdrawstatus: maxwithdrawstatus,
                        linelink: datas[1].value,
                        webnamex: datas[7].value,
                        System: res.data.tblcatagoryx[0].System,
                        cashoutSet: res.data.tblcashoutsetting[0],
                        inviteSet: res.data.tblinvitedsetting[0],
                        datas: datas,
                        limit: limit,
                    });
                }
                else {
                    // this.CheckThisGoalError();
                }
            });

            var decoded = jwt_decode(token);
            let Username = decoded.message.playerid;
            await instance.post("/api/v1/getredeempromotion", {
                userid: Username,
                System: Systems,
            }, {
                headers: { Authorization: `Bearer ${token}` }
            }).then(async (res) => {
                console.log(799, res);
                if (res.data.status === 200) {
                    this.setState({
                        proderedeem: res.data.message.tblpromotionredeems,
                    });

                }
            }).catch(async (err) => {
                console.log(err);
            });
        }
        catch (ex) {
            console.log(ex);
        }
    }

    openchangepassword = (e) => {
        if (e) e.preventDefault();
        this.setState({ changepassword: !this.state.changepassword });
    }

    resetpassword = async (e) => {
        if (e) e.preventDefault();
        const { oldpassword, password, passwordcf } = this.state;
        const token = localStorage.getItem('auth_token');
        if (!oldpassword || !password || !passwordcf) {
            return Swal.fire({ title: 'ແຈ້ງເຕືອນ', text: 'ກະລຸນາຕື່ມຂໍ້ມູນໃຫ້ຄົບ', icon: 'warning', confirmButtonText: 'ຕົກລົງ' });
        }
        if (password !== passwordcf) {
            return Swal.fire({ title: 'ແຈ້ງເຕືອນ', text: 'ລະຫັດຜ່ານໃໝ່ບໍ່ກົງກັນ', icon: 'warning', confirmButtonText: 'ຕົກລົງ' });
        }
        if (!token) {
            return Swal.fire({ title: 'ແຈ້ງເຕືອນ', text: 'ກະລຸນາເຂົ້າສູ່ລະບົບໃໝ່', icon: 'warning', confirmButtonText: 'ຕົກລົງ' });
        }
        try {
            const decoded = jwt_decode(token);
            const Username = decoded.message.playerid;
            const res = await instance.post("/api/v1/resetpassword", {
                username: Username,
                oldpass: oldpassword,
                newpass: password,
                System: Systems,
                type: 1
            }, { headers: { Authorization: `Bearer ${token}` } });
            if (res.data.status === 200) {
                this.setState({ oldpassword: "", password: "", passwordcf: "", changepassword: false });
                await Swal.fire({ title: 'ສຳເລັດ', text: 'ປ່ຽນລະຫັດຜ່ານຮຽບຮ້ອຍ', icon: 'success', confirmButtonText: 'ຕົກລົງ' });
            } else if (res.data.status === 201) {
                await Swal.fire({ title: 'ຜິດພາດ', text: 'ລະຫັດຜ່ານເກົ່າບໍ່ຖືກຕ້ອງ', icon: 'error', confirmButtonText: 'ຕົກລົງ' });
            } else if (res.data.status === 202) {
                await Swal.fire({ title: 'ຜິດພາດ', text: 'ລະຫັດຜ່ານໃໝ່ຊ້ຳກັບລະຫັດເກົ່າ', icon: 'error', confirmButtonText: 'ຕົກລົງ' });
            } else {
                await Swal.fire({ title: 'ຜິດພາດ', text: 'ມີຂໍ້ຜິດພາດ ກະລຸນາລອງອີກຄັ້ງ', icon: 'error', confirmButtonText: 'ຕົກລົງ' });
            }
        } catch (err) {
            console.log('resetpassword error', err);
            await Swal.fire({ title: 'ຜິດພາດ', text: 'ມີຂໍ້ຜິດພາດ ກະລຸນາລອງອີກຄັ້ງ', icon: 'error', confirmButtonText: 'ຕົກລົງ' });
        }
    }

    render() {
        const { proderedeem, username, accnumber, firstname, rankpoint, tblrankall, promotionredeem, linelink } = this.state;
        const accnumberx = Array.isArray(accnumber) && accnumber.length > 0 ? accnumber[0] : null;

        // Format account number 3-1-5-1
        let accFmt = "";
        if (accnumberx) {
            const r = (accnumberx.accno || "").replace(/\D/g, "");
            accFmt = r.length === 10
                ? `${r.substring(0,3)}-${r.substring(3,4)}-${r.substring(4,9)}-${r.substring(9,10)}`
                : r;
        }

        const currentRankName = this.state.rankname || "Bronze";
        const isDesktop = typeof window !== 'undefined' && window.innerWidth >= 900;

        const S = {
            page: { minHeight: "100vh", background: "#0d0d1a", color: "#fff", paddingBottom: 48 },
            header: {
                display: "flex", alignItems: "center", justifyContent: "space-between",
                padding: "18px 20px 14px 20px",
                borderBottom: "1px solid rgba(255,255,255,0.07)",
                background: "rgba(13,13,26,0.96)", backdropFilter: "blur(12px)",
            },
            backBtn: {
                width: 40, height: 40, borderRadius: "50%",
                background: "rgba(255,255,255,0.1)", border: "1px solid rgba(255,255,255,0.18)",
                display: "flex", alignItems: "center", justifyContent: "center", cursor: "pointer", textDecoration: "none", color: "#fff",
            },
            headerTitle: { fontSize: 17, fontWeight: 700, color: "#fff", letterSpacing: 0.5 },
            wrap: { maxWidth: 500, margin: "0 auto", padding: "20px 18px 0 18px" },
            // Hero card
            heroCard: {
                borderRadius: 22,
                background: "linear-gradient(135deg, #2a0545 0%, #0d1f46 55%, #052030 100%)",
                border: "1px solid rgba(185,3,253,0.5)",
                padding: "24px 22px 20px 22px",
                marginBottom: 22,
                position: "relative", overflow: "hidden",
                boxShadow: "0 4px 32px rgba(185,3,253,0.15)",
            },
            heroBg: {
                position: "absolute", top: -50, right: -50, width: 200, height: 200,
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(185,3,253,0.35) 0%, transparent 65%)",
                pointerEvents: "none",
            },
            heroBg2: {
                position: "absolute", bottom: -40, left: -40, width: 160, height: 160,
                borderRadius: "50%",
                background: "radial-gradient(circle, rgba(0,211,227,0.25) 0%, transparent 65%)",
                pointerEvents: "none",
            },
            avatarRing: {
                width: 76, height: 76, borderRadius: "50%",
                background: "linear-gradient(135deg, #b903fd, #00d3e3)",
                padding: 3, flexShrink: 0,
                boxShadow: "0 0 20px rgba(185,3,253,0.5)",
            },
            avatarInner: {
                width: "100%", height: "100%", borderRadius: "50%",
                background: "#1f0640",
                display: "flex", alignItems: "center", justifyContent: "center", overflow: "hidden",
            },
            usernameText: { fontSize: 18, fontWeight: 800, color: "#fff", marginBottom: 4 },
            rankBadge: {
                display: "inline-flex", alignItems: "center", gap: 5,
                background: "linear-gradient(90deg, rgba(185,3,253,0.4), rgba(0,211,227,0.25))",
                border: "1px solid rgba(185,3,253,0.65)",
                borderRadius: 20, padding: "4px 12px", fontSize: 12, color: "#e8c0ff", fontWeight: 700,
            },
            contactBtn: {
                display: "inline-flex", alignItems: "center", gap: 6,
                background: "rgba(0,211,227,0.12)", border: "1px solid rgba(0,211,227,0.45)",
                borderRadius: 20, padding: "7px 16px", fontSize: 13, color: "#00d3e3",
                textDecoration: "none", cursor: "pointer", marginTop: 16, fontWeight: 600,
            },
            // Section label
            sectionLabel: {
                fontSize: 11, fontWeight: 700, color: "rgba(255,255,255,0.5)",
                letterSpacing: 1.5, textTransform: "uppercase",
                marginBottom: 10, marginTop: 4, paddingLeft: 4,
            },
            // Card base
            card: {
                borderRadius: 16,
                background: "rgba(255,255,255,0.08)",
                border: "1px solid rgba(255,255,255,0.14)",
                padding: "18px",
                marginBottom: 18,
            },
            // Bank card
            bankCard: {
                borderRadius: 18,
                background: "linear-gradient(135deg, rgba(0,211,227,0.18), rgba(185,3,253,0.10))",
                border: "1px solid rgba(0,211,227,0.45)",
                padding: "18px 20px",
                marginBottom: 22,
                display: "flex", alignItems: "center", gap: 16,
                boxShadow: "0 2px 24px rgba(0,211,227,0.08)",
            },
            bankLogo: { width: 52, height: 52, borderRadius: 14, objectFit: "cover", flexShrink: 0, background: "#111", border: "1px solid rgba(255,255,255,0.1)" },
            bankName: { fontSize: 13, color: "rgba(255,255,255,0.6)", marginBottom: 3 },
            bankOwner: { fontSize: 14, color: "#00d3e3", fontWeight: 700, marginBottom: 5 },
            bankAccno: { fontSize: 19, fontWeight: 900, color: "#fff", letterSpacing: 2 },
            // Promo card
            promoCard: {
                borderRadius: 18,
                background: "rgba(251,191,36,0.10)",
                border: "1px solid rgba(251,191,36,0.4)",
                padding: "18px 20px",
                marginBottom: 22,
                boxShadow: "0 2px 20px rgba(251,191,36,0.06)",
            },
            promoTitle: { fontSize: 12, color: "rgba(255,255,255,0.5)", marginBottom: 6, textTransform: "uppercase", letterSpacing: 0.8 },
            promoName: { fontSize: 16, fontWeight: 700, color: "#fbbf24", marginBottom: 12 },
            turnoverRow: { display: "flex", justifyContent: "space-between", alignItems: "center", fontSize: 13, color: "rgba(255,255,255,0.6)" },
            progressBar: { height: 7, background: "rgba(255,255,255,0.1)", borderRadius: 8, overflow: "hidden", margin: "10px 0 6px 0" },
            progressFill: (pct) => ({ height: "100%", width: pct + "%", background: "linear-gradient(90deg,#00d3e3,#b903fd)", borderRadius: 8 }),
            cancelBtn: {
                fontSize: 12, color: "#ff6b6b", cursor: "pointer",
                background: "rgba(255,82,82,0.14)", border: "1px solid rgba(255,82,82,0.35)",
                borderRadius: 20, padding: "4px 12px", fontWeight: 600,
            },
            // Rank items
            rankItem: (done, claimable) => ({
                borderRadius: 16,
                background: done
                    ? "rgba(0,211,227,0.12)"
                    : claimable
                    ? "rgba(185,3,253,0.15)"
                    : "rgba(255,255,255,0.06)",
                border: `1px solid ${done ? "rgba(0,211,227,0.45)" : claimable ? "rgba(185,3,253,0.55)" : "rgba(255,255,255,0.12)"}`,
                padding: "14px 16px",
                marginBottom: 10,
                display: "flex", alignItems: "center", gap: 14,
                boxShadow: claimable ? "0 2px 16px rgba(185,3,253,0.12)" : "none",
            }),
            rankImg: { width: 54, height: 54, objectFit: "contain", flexShrink: 0 },
            rankName: { fontSize: 15, fontWeight: 700, color: "#fff", marginBottom: 3 },
            rankDesc: { fontSize: 12, color: "rgba(255,255,255,0.55)", lineHeight: 1.5 },
            rankStatus: (done, claimable) => ({
                marginLeft: "auto", flexShrink: 0, fontSize: 12, fontWeight: 700,
                padding: "7px 14px", borderRadius: 20,
                background: done
                    ? "rgba(0,211,227,0.2)"
                    : claimable
                    ? "linear-gradient(90deg,#b903fd,#7c00c9)"
                    : "rgba(255,255,255,0.08)",
                color: done ? "#00d3e3" : claimable ? "#fff" : "rgba(255,255,255,0.3)",
                border: done ? "1px solid rgba(0,211,227,0.5)" : "none",
                cursor: claimable ? "pointer" : "default",
                whiteSpace: "nowrap",
            }),
        };

        // ຍອດເທີນຈິງ = account-level (TurnOverAmount = เป้า, Turnovercasino+Turnoverslot = ຫຼິ້ນໄປແລ້ວ)
        // ใช้ค่าที่ backend คิดจริง (ตัวเดียวกับที่เช็คตอนถอน) ไม่ใช่ field ในโปรที่ไม่ได้ส่งมา
        const _tTarget = Number(this.state.turnover) || 0;
        const _tDone = Number(this.state.turnoverdone) || 0;
        const _tRemain = Math.max(0, _tTarget - _tDone);
        let turnPct = _tTarget > 0 ? Math.min(100, Math.round((_tDone / _tTarget) * 100)) : (promotionredeem ? 0 : 100);
        let turnText = `ຍອດເທີນ ${_tDone.toLocaleString()} / ${_tTarget.toLocaleString()}`;
        let maxWdText = promotionredeem
            ? `ຖອນສູງສຸດ ${Number(promotionredeem.maxwithdraw || 0).toLocaleString()} ກີບ`
            : `ຍອດເຫຼືອ ${_tRemain.toLocaleString()} ກີບ`;

        const activePromoName = (proderedeem && proderedeem.length > 0)
            ? proderedeem[0].proname
            : (promotionredeem ? promotionredeem.proname : null);

        // Shared blocks
        const heroBlock = (
            <div style={S.heroCard}>
                <div style={S.heroBg} />
                <div style={S.heroBg2} />
                <div style={{ display: "flex", alignItems: "center", gap: 16, position: "relative" }}>
                    <div style={S.avatarRing}>
                        <div style={S.avatarInner}>
                            <img
                                src="/build/web/igame-index-lobby-wm/img/ic-rank-credit-top-01.png"
                                alt="avatar"
                                style={{ width: isDesktop ? 80 : 62, height: isDesktop ? 80 : 62, objectFit: "cover" }}
                            />
                        </div>
                    </div>
                    <div style={{ flex: 1 }}>
                        <div style={S.usernameText}>{firstname || username}</div>
                        <div style={{ fontSize: 13, color: "rgba(255,255,255,0.45)", marginBottom: 6 }}>{username}</div>
                        <div style={S.rankBadge}>
                            <span>⭐</span>
                            <span>{currentRankName}</span>
                        </div>
                    </div>
                </div>
                <a href={linelink} target="_blank" rel="noopener noreferrer" style={S.contactBtn}>
                    <svg xmlns="http://www.w3.org/2000/svg" width={14} height={14} fill="currentColor" viewBox="0 0 16 16">
                        <path d="M8 1C3.685 1 0 3.538 0 6.666c0 1.928 1.187 3.636 3 4.704v2.13l2.093-1.29c.56.152 1.254.236 1.907.236 4.314 0 8-2.538 8-5.667S12.314 1 8 1z"/>
                    </svg>
                    ຕິດຕໍ່ຝ່າຍບໍລິການລູກຄ້າ
                </a>
            </div>
        );

        const bankBlock = (
            <>
                <div style={S.sectionLabel}>ບັນຊີທະນາຄານ</div>
                {accnumberx ? (
                    <div style={S.bankCard}>
                        <img src={accnumberx.img_path || ""} alt={accnumberx.fullname_th} style={S.bankLogo} />
                        <div style={{ flex: 1 }}>
                            <div style={S.bankName}>{accnumberx.fullname_th || accnumberx.acro || "ທະນາຄານ"}</div>
                            <div style={S.bankOwner}>{firstname || username}</div>
                            <div style={S.bankAccno}>{accFmt}</div>
                        </div>
                    </div>
                ) : (
                    <div style={{ ...S.card, textAlign: "center", color: "rgba(255,255,255,0.3)", fontSize: 14, marginBottom: 22 }}>
                        ບໍ່ພົບບັນຊີທີ່ລົງທະບຽນ
                    </div>
                )}
            </>
        );

        const promoBlock = (
            <>
                <div style={S.sectionLabel}>ໂປຣໂມຊັ່ນ</div>
                <div style={S.promoCard}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
                        <div>
                            <div style={S.promoTitle}>ໂປຣໂມຊັ່ນທີ່ໃຊ້ຢູ່</div>
                            <div style={S.promoName}>
                                {activePromoName
                                    ? <><span>🎁 </span>{activePromoName}</>
                                    : <span style={{ color: "rgba(255,255,255,0.35)", fontWeight: 400 }}>ບໍ່ຮັບໂບນັສ</span>
                                }
                            </div>
                        </div>
                        {proderedeem && proderedeem.length > 0 && (
                            <button style={S.cancelBtn} onClick={(e) => this.cancelredeempromotion(e, proderedeem)}>
                                ຍົກເລີກ
                            </button>
                        )}
                    </div>
                    <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12, color: "rgba(255,255,255,0.5)", marginBottom: 4 }}>
                        <span>{turnText}</span>
                        <span style={{ color: "#fbbf24" }}>{turnPct}%</span>
                    </div>
                    <div style={S.progressBar}><div style={S.progressFill(turnPct)} /></div>
                    <div style={{ fontSize: 12, color: "rgba(255,255,255,0.4)", textAlign: "right" }}>{maxWdText}</div>
                </div>
            </>
        );

        // ===== ເປົ້າໝາຍລະດັບຕໍ່ໄປ (progress แรงค์) =====
        const _fmt = (v) => Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const _rp = Number(rankpoint) || 0;
        let _nextRank = null;
        if (Array.isArray(tblrankall) && tblrankall.length > 0) {
            const _sorted = tblrankall.slice().sort((a, b) => Number(a.lowamount || 0) - Number(b.lowamount || 0));
            _nextRank = _sorted.find((r) => Number(r.lowamount || 0) > _rp) || null;
        }
        const _nextReq = _nextRank ? Number(_nextRank.lowamount || 0) : 0;
        const _nextPct = _nextReq > 0 ? Math.min(100, Math.round((_rp / _nextReq) * 100)) : 100;
        const _nextBonus = _nextRank ? Number(_nextRank.claimamount || 0) : 0;
        const nextRankBlock = (
            <>
                <div style={S.sectionLabel}>ເປົ້າໝາຍລະດັບຕໍ່ໄປ</div>
                <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 14, padding: 18, marginBottom: 22 }}>
                    {_nextRank ? (
                        <>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 8 }}>
                                <span style={{ fontSize: 22, fontWeight: 800, color: "#fff" }}>{_nextPct} %</span>
                                <span style={{ fontSize: 13, color: "#60a5fa", fontWeight: 600 }}>ໄປທີ່ {_nextRank.name}</span>
                            </div>
                            <div style={{ height: 12, borderRadius: 8, background: "rgba(255,255,255,0.10)", overflow: "hidden", marginBottom: 12 }}>
                                <div style={{ height: "100%", width: _nextPct + "%", background: "linear-gradient(90deg,#3b82f6,#2563eb)", borderRadius: 8, transition: "width .4s" }} />
                            </div>
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-end" }}>
                                <div>
                                    <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)" }}>ຍອດຝາກປັດຈຸບັນ</div>
                                    <div style={{ fontSize: 18, fontWeight: 800, color: "#34d399" }}>{_fmt(_rp)} ກີບ</div>
                                </div>
                                <div style={{ textAlign: "right" }}>
                                    <div style={{ fontSize: 12, color: "rgba(255,255,255,0.5)" }}>ທ່ານຕ້ອງເຮັດຍອດຝາກ</div>
                                    <div style={{ fontSize: 18, fontWeight: 800, color: "#fbbf24" }}>{_fmt(_nextReq)} ກີບ</div>
                                </div>
                            </div>
                            {_nextBonus > 0 && (
                                <div style={{ marginTop: 12, textAlign: "center", fontSize: 13, color: "#fff", background: "rgba(124,58,237,0.18)", border: "1px solid rgba(124,58,237,0.4)", borderRadius: 10, padding: "8px 10px" }}>
                                    <span>🎁 </span>ຝາກອີກ {_fmt(Math.max(0, _nextReq - _rp))} ກີບ ຮັບເຄຣດິດຟຣີ {_fmt(_nextBonus)} ກີບ ທີ່ລະດັບ {_nextRank.name}
                                </div>
                            )}
                        </>
                    ) : (
                        <div style={{ textAlign: "center", color: "#ffd97a", fontSize: 15, fontWeight: 700, padding: "6px 0" }}><span>🏆 </span>ທ່ານຢູ່ລະດັບສູງສຸດແລ້ວ</div>
                    )}
                </div>
            </>
        );

        // ===== ປ່ຽນລະຫັດຜ່ານ =====
        const inputStyle = { width: "100%", padding: "12px 14px", borderRadius: 10, border: "1px solid rgba(255,255,255,0.15)", background: "rgba(0,0,0,0.25)", color: "#fff", fontSize: 14, marginBottom: 10, boxSizing: "border-box" };
        const passwordBlock = (
            <>
                <div style={S.sectionLabel}>ຄວາມປອດໄພ</div>
                <div style={{ background: "rgba(255,255,255,0.03)", border: "1px solid rgba(255,255,255,0.08)", borderRadius: 14, padding: 16, marginBottom: 22 }}>
                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", cursor: "pointer" }} onClick={this.openchangepassword}>
                        <span style={{ fontSize: 14, color: "#fff", fontWeight: 600 }}>🔒 ປ່ຽນລະຫັດຜ່ານ</span>
                        <span style={{ fontSize: 12, color: "#60a5fa" }}>{this.state.changepassword ? "ປິດ ▲" : "ເປີດ ▼"}</span>
                    </div>
                    {this.state.changepassword && (
                        <div style={{ marginTop: 14 }}>
                            <style>{`.starbet-pass-input::placeholder{color:#ffffff !important;opacity:1 !important;} .starbet-pass-input::-webkit-input-placeholder{color:#ffffff !important;opacity:1 !important;} .starbet-pass-input::-moz-placeholder{color:#ffffff !important;opacity:1 !important;} .starbet-pass-input:-ms-input-placeholder{color:#ffffff !important;}`}</style>
                            <input className="starbet-pass-input" type="password" placeholder="ລະຫັດຜ່ານເກົ່າ" value={this.state.oldpassword}
                                onChange={(e) => this.setState({ oldpassword: e.target.value })}
                                style={inputStyle} autoComplete="current-password" />
                            <input className="starbet-pass-input" type="password" placeholder="ລະຫັດຜ່ານໃໝ່" value={this.state.password}
                                onChange={(e) => this.setState({ password: e.target.value })}
                                style={inputStyle} autoComplete="new-password" />
                            <input className="starbet-pass-input" type="password" placeholder="ຢືນຢັນລະຫັດຜ່ານໃໝ່" value={this.state.passwordcf}
                                onChange={(e) => this.setState({ passwordcf: e.target.value })}
                                style={inputStyle} autoComplete="new-password" />
                            <button onClick={this.resetpassword}
                                style={{ width: "100%", padding: "12px", borderRadius: 10, border: "none", background: "linear-gradient(135deg,#7c3aed,#4f46e5)", color: "#fff", fontWeight: 700, fontSize: 15, cursor: "pointer", marginTop: 4 }}>
                                ບັນທຶກລະຫັດຜ່ານໃໝ່
                            </button>
                        </div>
                    )}
                </div>
            </>
        );

        const rankBlock = tblrankall && tblrankall.length > 0 && (
            <>
                <div style={S.sectionLabel}>ລະດັບສະມາຊິກ</div>
                {tblrankall.map((item, i) => {
                    const isFirst = item.no === 1;
                    const meetsCondition = Number(item?.lowamount || 0) <= rankpoint;
                    const done = !isFirst && meetsCondition && !item.checked;
                    const claimable = !isFirst && item.checked;
                    return (
                        <div key={i} style={S.rankItem(done, claimable)}>
                            <img src={"/build/rank/" + item.image} alt={item.name} style={S.rankImg} />
                            <div style={{ flex: 1 }}>
                                <div style={S.rankName}>{item.name}</div>
                                <div style={S.rankDesc}>
                                    ເຕີມ {Number(item?.lowamount || 0).toLocaleString()} ກີບຂຶ້ນໄປ
                                    {!isFirst && ` • ໂບນັສ ${Number(item?.claimamount || 0).toLocaleString()} ກີບ`}
                                </div>
                            </div>
                            {!isFirst && (
                                done ? (
                                    <div style={S.rankStatus(true, false)}>✓ ສຳເລັດ</div>
                                ) : claimable ? (
                                    <button style={{ ...S.rankStatus(false, true), border: "none" }} onClick={(e) => this.redeemrank(e, item)}>
                                        ຮັບລາງວັນ
                                    </button>
                                ) : (
                                    <div style={S.rankStatus(false, false)}>ຍັງບໍ່ຜ່ານ</div>
                                )
                            )}
                        </div>
                    );
                })}
            </>
        );

        return (
            <div style={S.page}>
                {/* Header */}
                <div style={S.header}>
                    <a href="/" style={S.backBtn}>
                        <svg xmlns="http://www.w3.org/2000/svg" width={18} height={18} fill="currentColor" viewBox="0 0 16 16">
                            <path fillRule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
                        </svg>
                    </a>
                    <span style={S.headerTitle}>ຂໍ້ມູນບັນຊີ</span>
                    <div style={{ width: 38 }} />
                </div>

                {!isDesktop ? (
                    /* ── Mobile: single column ── */
                    <div style={S.wrap}>
                        {heroBlock}
                        {bankBlock}
                        {nextRankBlock}
                        {promoBlock}
                        {passwordBlock}
                        {rankBlock}
                    </div>
                ) : (
                    /* ── Desktop: 2-column grid ── */
                    <div style={{ maxWidth: 1140, margin: "0 auto", padding: "24px 28px 48px 28px", display: "flex", gap: 28, alignItems: "flex-start" }}>
                        {/* Left column */}
                        <div style={{ width: 380, flexShrink: 0 }}>
                            {heroBlock}
                            {bankBlock}
                            {passwordBlock}
                        </div>
                        {/* Right column */}
                        <div style={{ flex: 1, minWidth: 0 }}>
                            {nextRankBlock}
                            {promoBlock}
                            {rankBlock}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}
export default App;
